import { onCleanup, untrack } from "solid-js";

/**
 * AC22 — il numero che questa feature deve far calare: l'abbandono della
 * pagina durante la loading screen della prima ricerca. Registrato in
 * `onCleanup` della route: se al momento dello smontaggio la loading screen
 * è visibile (richiesta in volo, nessun dato mostrabile né conservato),
 * l'utente se n'è andato prima della prima risposta.
 *
 * Unica fonte di verità: lo stesso stato di T4 (`startedAt` + visibilità),
 * nessun secondo orologio.
 */
export function useSearchAbandonTracking(opts: {
  isLoadingVisible: () => boolean;
  startedAt: () => number;
  capture: (
    event: "cancel_semantic_search",
    properties: { elapsed_ms: number; search_type: "first" },
  ) => void;
}) {
  onCleanup(() => {
    if (!untrack(() => opts.isLoadingVisible())) return;
    opts.capture("cancel_semantic_search", {
      elapsed_ms: Math.max(0, Date.now() - untrack(() => opts.startedAt())),
      search_type: "first",
    });
  });
}
